// Licences
export const Licences = Object.freeze({
  PT: 'PT',
  IT: 'IT',
  ES: 'ES',
  FR: 'FR',
  DE: 'DE'
});

// Locales
export const Locales = Object.freeze({
  EN: 'en',
  DE: 'de',
  PT: 'pt',
  IT: 'it',
  ES: 'es',
  FR: 'fr'
});


export const LocalesLong = Object.freeze({
  [Locales.EN]: 'en_US',
  [Locales.DE]: 'de_DE',
  [Locales.PT]: 'pt_PT',
  [Locales.IT]: 'it_IT',
  [Locales.ES]: 'es_ES',
  [Locales.FR]: 'fr_FR'
});
